import { createSelector } from 'reselect';
import get from 'lodash/get';
import config from '../../config';
import { getVerifiedToTradeStatus } from '../../helpers/verificationRequiredHelper';
import { findIndexOfObject } from '../../helpers/arrayHelper';
export var kycVerificationLevelsSelector = createSelector([function (state) {
  return state.user.selectedAccountId;
}, function (state) {
  return state.user.accounts;
}, function (state) {
  return state.user.userConfig;
}], function (AccountId, accounts, userConfig) {
  var _ref = accounts.find(function (account) {
      return account.AccountId === AccountId;
    }) || {},
    verificationLevel = _ref.VerificationLevel;
  var kycConfig = get(config, 'KYC', {});
  var levelIncreaseStatus = (userConfig.find(function (config) {
    return config.Key === 'levelIncreaseStatus';
  }) || {}).Value;
  levelIncreaseStatus = kycConfig.type === 'Manual' ? Number(levelIncreaseStatus) : levelIncreaseStatus;
  var _getVerifiedToTradeSt = getVerifiedToTradeStatus(verificationLevel, levelIncreaseStatus),
    isUnderReview = _getVerifiedToTradeSt.isUnderReview,
    disableTrading = _getVerifiedToTradeSt.disableTrading;
  var disableWithdraw = verificationLevel < config.Withdraw.MinimumVerificationLevel;
  var disableDeposit = verificationLevel < config.Deposit.MinimumVerificationLevel;
  return {
    kycConfig: kycConfig,
    levelIncreaseStatus: levelIncreaseStatus,
    verificationLevel: verificationLevel,
    disableTrading: disableTrading,
    isUnderReview: isUnderReview,
    disableWithdraw: disableWithdraw,
    disableDeposit: disableDeposit
  };
});
export var kycLevelFormSelector = createSelector([function (state) {
  return state.apiProcessing;
}, function (state) {
  return state.user.userInfo;
}, function (state) {
  return state.user.accounts;
}, function (state) {
  return state.user.userConfig;
}, function (state) {
  return state.user.kyc;
}, function (state) {
  return state.auth.token;
}], kycLevelFormSelectorCallback);
export function kycLevelFormSelectorCallback(apiProcessing, userInfo, accounts, userConfig, kyc, token) {
  var AccountId = userInfo.AccountId,
    UserId = userInfo.UserId,
    userName = userInfo.UserName,
    email = userInfo.Email;
  var levelIncreaseStatus = (userConfig.filter(function (config) {
    return config.Key === 'levelIncreaseStatus';
  })[0] || {}).Value;
  var _ref2 = accounts.filter(function (account) {
      return account.AccountId === AccountId;
    })[0] || {},
    verificationLevel = _ref2.VerificationLevel;
  var kycConfig = get(config, 'KYC', {});
  var processing = kycConfig.type === 'Manual' ? apiProcessing.processingSetUserConfig : apiProcessing.processingValidateUserRegistration;
  var levelIncreaseStatusIndex = findIndexOfObject(userConfig, 'Key', 'levelIncreaseStatus');
  return {
    alphaPointSessiontoken: token,
    alphaPointUserID: UserId + '',
    userConfig: userConfig,
    userName: userName,
    email: email,
    verificationLevel: verificationLevel,
    levelIncreaseStatus: levelIncreaseStatus,
    kycConfig: kycConfig,
    kyc: kyc,
    processing: processing,
    levelIncreaseStatusIndex: levelIncreaseStatusIndex
  };
}